import { Component, OnInit } from '@angular/core';

import { SharedRankingListService } from 'src/app/@theme/components/shared-ranking-list/shared-ranking-list.service';

import * as Constants from 'src/app/core/constants';

@Component({
    selector: 'app-kids-ranking',
    templateUrl: './kids-ranking.component.html',
    styleUrls: ['./kids-ranking.component.scss'],
})
export class KidsRankingComponent implements OnInit {
    /**
     * Definição da identificão da sessão/depto Beachtennis
     */
    constants = Constants;
    public departmentType: string = this.constants.DEPARTMENT_TYPE_KIDS;
    public pathRoute: string = this.constants.DEPARTMENT_PATH_KIDS;

    constructor(private rankingListService: SharedRankingListService) {}

    ngOnInit(): void {}
}
